import { FacilityKind } from "@ecp-redux/dto/warehouses.types";

export const WAREHOUSES_RESPONSE = {
  nearestFacilities: [
    {
      id: 12,
      name: "Stajnia Marzeń",
      facilityKind: FacilityKind.FM,
      country: null,
      city: null,
      zipCode: null,
      street: null,
      active: true,
      selected: false,
      defaultFacility: false,
    },
  ],
  recentFacilities: [
    {
      id: 3,
      name: "Obora Wypasów",
      facilityKind: FacilityKind.FM,
      country: null,
      city: null,
      zipCode: null,
      street: null,
      active: true,
      selected: true,
      defaultFacility: false,
    },
    {
      id: 5,
      name: "Kuźnia Wariactw Wariactw Wariactw Wariactw Wariactw",
      facilityKind: FacilityKind.FM,
      country: null,
      city: null,
      zipCode: null,
      street: null,
      active: true,
      selected: false,
      defaultFacility: false,
    },
    {
      id: 1,
      name: "Buda Skrzata",
      facilityKind: FacilityKind.FM,
      country: null,
      city: null,
      zipCode: null,
      street: null,
      active: false,
      selected: false,
      defaultFacility: false,
    },
  ],
};

export const ALL_WAREHOUSES_RESPONSE = {
  result: [
    {
      id: 11,
      externalId: "11",
      code: "11",
      name: "Magazyn Krów i Świń - ŚwińPOL",
      street: "Ks. Dominika Maja",
      streetNumber: "12",
      flatNumber: "2",
      city: "Lublin",
      zipCode: "23-100",
      distanceToRequestedLocalization: "",
      voivodeship: "Lubelskie",
      country: "",
      clickAndCollect: "",
      floor: "",
      clickAndCollectPrice: 0,
      geoLatitude: "51.2338600",
      geoLongitude: "22.5394200",
      openingHours: [
        {
          days: "",
          hours: "",
        },
      ],
      phone: "",
      webPageUrl: "",
      email: "",
      photoLocation: "",
      facilityKind: FacilityKind.FM,
      active: true,
      archive: false,
    },
    {
      code: "12",
      id: 12,
      externalId: "11",
      name: "Sklep z podrobami - Chlewnia",
      street: "Wojciechowska",
      streetNumber: "5C",
      flatNumber: "73",
      city: "Warszawa",
      zipCode: "20-704",
      distanceToRequestedLocalization: "",
      voivodeship: "Lubelskie",
      country: "",
      clickAndCollect: "",
      floor: "",
      clickAndCollectPrice: 0,
      geoLatitude: "52.2297700",
      geoLongitude: "21.0117800",
      openingHours: [
        {
          days: "",
          hours: "",
        },
      ],
      phone: "",
      webPageUrl: "",
      email: "",
      photoLocation: "",
      facilityKind: FacilityKind.FILIA,
      active: true,
      archive: false,
    },
    {
      code: "13",
      id: 13,
      externalId: "11",
      name: "Biuro Techniczno Handlowe - Siemano",
      street: "Turobińska",
      streetNumber: "17",
      flatNumber: "14",
      city: "Kraków",
      zipCode: "12-333",
      distanceToRequestedLocalization: "",
      voivodeship: "Lubelskie",
      country: "",
      clickAndCollect: "",
      floor: "",
      clickAndCollectPrice: 0,
      geoLatitude: "50.0614300",
      geoLongitude: "19.9365800",
      openingHours: [
        {
          days: "",
          hours: "",
        },
      ],
      phone: "",
      webPageUrl: "",
      email: "",
      photoLocation: "",
      facilityKind: FacilityKind.BTH,
      active: true,
      archive: false,
    },
    {
      code: "14",
      id: 14,
      externalId: "11",
      name: "Regionalne Centrum Dojenia Bydła Rogatego - Wymiono",
      street: "Turobińska",
      streetNumber: "17",
      flatNumber: "14",
      city: "Gdańsk",
      zipCode: "12-333",
      distanceToRequestedLocalization: "",
      voivodeship: "Lubelskie",
      country: "",
      clickAndCollect: "",
      floor: "",
      clickAndCollectPrice: 0,
      geoLatitude: "54.3520500",
      geoLongitude: "18.6463700",
      openingHours: [
        {
          days: "",
          hours: "",
        },
      ],
      phone: "",
      webPageUrl: "",
      email: "",
      photoLocation: "",
      facilityKind: FacilityKind.RCL,
      active: true,
      archive: false,
    },
  ],
};
